import { useRoleIdentifier } from "@/_shared/mixins/useRoleIdentifier";
import { objectHelper } from "@/_shared/utils/objectHelper";

export const useForm = {
  mixins: [useRoleIdentifier],
  data() {
    return {
      fallbackLink: "/cloths",
      isEditMode: false,
      isLoadingNow: false,
      entityName: {
        readonly: "Ткань",
        modify: "ткани",
      },
      wasDisabled: false,
      form: {},
    };
  },
  mounted() {
    const isVipUser = this.checkVipRole();
    if (!isVipUser && this.actionType === "add") {
      this.showErrorNotification("Недостаточно прав для совершения действия");
      this.$router.push("/");
    }
  },
  computed: {
    actionType() {
      if (this.getSlug() === "new") {
        return "add";
      }
      return this.isEditMode ? "edit" : "read";
    },
    subtitle() {
      if (!this.isEditMode && this.getSlug() !== "new") {
        return `${this.entityName.readonly} #${this.getSlug()}`;
      }
      return this.getSlug() === "new"
        ? `Добавление ${this.entityName.modify}`
        : `Редактирование ${this.entityName.modify} #${this.getSlug()}`;
    },
  },
  methods: {
    setEditMode(flag = true) {
      if (!flag) {
        this.$router.go();
      }
      this.isLoadingNow = true;
      setTimeout(() => {
        this.isEditMode = flag;
        this.isLoadingNow = false;
      }, 500);
    },
    isRequiredField(field = {}) {
      if (this.actionType === "read") {
        return false;
      }
      return !!(typeof field.required !== "undefined");
    },
    async setFormFields(addingFields = {}, editingFieldsGetter) {
      if (this.getSlug() === "new") {
        return (this.form = addingFields);
      }
      this.isLoadingNow = true;
      const recordId = this.getSlug();
      await editingFieldsGetter(recordId).
        then((editingRecord) => {
          this.form = objectHelper.removeNonFormProperties(editingRecord);
          this.isLoadingNow = false;
        })
        .catch(() => {
          this.$router.push('/');
          const message = 'Возможно, такой записи не существует';
          this.showErrorNotification(message);
        });
    },
    getSlug() {
      const { fullPath } = this.$router.currentRoute;
      const slug = fullPath.split("/").pop();
      return slug;
    },
    async sendForm(apiCallback, withValidation = true) {
      this.wasDisabled = true;
      const formIsInvalid = this.$v.$invalid;
      try {
        if (withValidation && formIsInvalid) {
          throw new Error("Проверьте обязательные поля");
        }
        await apiCallback()
          .then(({ data }) => {
            const DEFAULT_MESSAGE = "Форма была успешно отправлена";
            const message = data.message ? data.message : DEFAULT_MESSAGE;
            this.showSuccessNotification(message);
            setTimeout(() => {
              this.$router.go(-1);
              this.$router.push(this.fallbackLink);
            }, 1000);
          })
          .catch((error) => {
            throw new Error(error.message);
          });
      } catch (error) {
        this.showErrorNotification(error.message);
        this.wasDisabled = false;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/_shared/mixins/useForm.js